import { render, staticRenderFns } from "./subject-property-existing-mortgage.vue?vue&type=template&id=bffc01c6"
import script from "./subject-property-existing-mortgage.vue?vue&type=script&lang=ts"
export * from "./subject-property-existing-mortgage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports